import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Input,
  FormGroup,
  Label,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  Tooltip,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  gAPI_Property_List_By_Group,
  API_AZURE_INTEGRATION,
} from '../../../../../../constants/APIs';
import Validation from '../../../../../../components/Validation';
import { CopyToClipboard } from 'react-copy-to-clipboard';
let arr = [];
function AzureIntegration({
  visible,
  toggle,
  id,
  LoadIntegrations,
  serviceProvider,
}) {
  console.log('serviceProvider', serviceProvider);
  const [property, setProperty] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [maskData, setMaskData] = useState({
    accessSecretKey: '',
    accessKeyId: '',
  });
  const [titleToolTip, settitleToolTip] = useState(false);
  const [showRatesRadios, setRatesRadios] = useState(false);
  const [inputData, setInputData] = useState({
    groupId: getGroupID(),
    name: '',
    properties: [],
    sessionTimeoutInSeconds: 600,
    defaultLanguage: 'en-US',
    clientId: '',
    tenantId: '',
    clientSecret: '',
  });
  const [copied, setCopied] = useState('');
  const toggleTitleToolTip = () => {
    settitleToolTip(!titleToolTip);
  };
  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${API_AZURE_INTEGRATION}/${id}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setInputData({
            ...inputData,
            name: res.data.name,
            properties: res.data.properties !== null ? res.data.properties : [],
            clientId: res.data.channelDetails.clientId,
            tenantId: res.data.channelDetails.tenantId,
            clientSecret: res.data.channelDetails.clientSecret,
          });

          setMaskData({
            ...maskData,
            clientSecret: mask(res.data.channelDetails.clientSecret),
          });
        })
        .catch((err) => console.log('err', err));

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    }
  }, [id]);
  const mask = (value) => {
    let maskedValue = '';
    for (let i = 0; i < value.length - 2; i++) {
      maskedValue += '*';
    }
    return maskedValue + value.substring(value.length - 2, value.length);
  };

  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, name: e.target.value });
  };

  const handleAccessSecretKeyChange = (e) => {
    e.persist();
    setMaskData({ ...maskData, clientSecret: mask(e.target.value) });
    setInputData({ ...inputData, clientSecret: e.target.value });
  };

  const handleChange = (e) => {
    e.persist();
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };
  const handleCheckChange = (e) => {
    const propertyId = e.target.value;
    let updatedProperties = [...inputData.properties];

    if (e.target.checked) {
      // Add property if checked and not already present
      if (!updatedProperties.includes(propertyId)) {
        updatedProperties.push(propertyId);
      }
    } else {
      // Remove property if unchecked
      updatedProperties = updatedProperties.filter((id) => id !== propertyId);
    }

    setInputData({ ...inputData, properties: updatedProperties });
  };

  const handleSave = async () => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'put',
        url: `${API_AZURE_INTEGRATION}/${id}?group_id=${getGroupID()}`,
        data: inputData,
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          toggle();
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      });
    } else {
      AxiosAPI({
        method: 'post',
        url: API_AZURE_INTEGRATION,
        data: inputData,
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          toggle();
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      });
    }
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>{id === undefined ? 'Add' : 'Update'} Integration</h6>
                <Separator className="mb-3" />
                <Form className="text-left">
                  <FormGroup className="mb-2">
                    <Label>Integration Name</Label>
                    <Input
                      type="text"
                      name="integrationName"
                      onChange={handleNameChange}
                      placeholder="Integration Name"
                      defaultValue={inputData.name}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Client Id</Label>
                    <Input
                      type="text"
                      name="clientId"
                      onChange={handleChange}
                      placeholder="Client Id"
                      defaultValue={inputData.clientId}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Tenant Id</Label>
                    <Input
                      type="text"
                      name="tenantId"
                      onChange={handleChange}
                      placeholder="Tenant Id"
                      defaultValue={inputData.tenantId}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Client Secret</Label>
                    <Input
                      type="text"
                      name="clientSecret"
                      onChange={handleAccessSecretKeyChange}
                      placeholder="Client Secret"
                      defaultValue={maskData.clientSecret}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label
                      className="text-muted"
                      style={{ fontWeight: 'normal', fontSize: '13px' }}
                    >
                      <strong>
                        Redirect URLs Required for Azure App Registration:
                      </strong>
                      <ul
                        style={{
                          paddingLeft: '18px',
                          marginBottom: '0',
                          marginTop: '8px',
                        }}
                      >
                        <li>
                          <b>Dashboard Access:</b>
                          <br />
                          <span style={{ wordBreak: 'break-all' }}>
                            {serviceProvider == "5"
                              ? `${process.env.REACT_APP_SYNXIS_AUTHORITY_SERVER}/account/ssologinfinalstep`
                              : `${process.env.REACT_APP_MYMA_AUTHORITY_SERVER}/account/ssologinfinalstep`}
                          </span>

                          <CopyToClipboard
                            text={`${process.env.REACT_APP_MYMA_AUTHORITY_SERVER}/account/ssologinfinalstep`}
                            onCopy={() => setCopied('dashboard')}
                          >
                            <Button
                              size="xs"
                              color="link"
                              style={{ marginLeft: '8px', padding: '0 6px' }}
                            >
                              <i className="simple-icon-docs" />{' '}
                              {/* Copy icon */}
                            </Button>
                          </CopyToClipboard>
                          {copied === 'dashboard' && (
                            <span
                              style={{
                                color: 'green',
                                marginLeft: '5px',
                                fontSize: '12px',
                              }}
                            >
                              Copied!
                            </span>
                          )}
                        </li>
                        <li style={{ marginTop: '8px' }}>
                          <b>Chatbot Access:</b>
                          <br />
                          <span style={{ wordBreak: 'break-all' }}>
                            {process.env.REACT_APP_CHAT_API}/azure-auth/callback
                          </span>
                          <CopyToClipboard
                            text={`${process.env.REACT_APP_CHAT_API}/azure-auth/callback`}
                            onCopy={() => setCopied('chatbot')}
                          >
                            <Button
                              size="xs"
                              color="link"
                              style={{ marginLeft: '8px', padding: '0 6px' }}
                            >
                              <i className="simple-icon-docs" />{' '}
                              {/* Copy icon */}
                            </Button>
                          </CopyToClipboard>
                          {copied === 'chatbot' && (
                            <span
                              style={{
                                color: 'green',
                                marginLeft: '5px',
                                fontSize: '12px',
                              }}
                            >
                              Copied!
                            </span>
                          )}
                        </li>
                      </ul>
                      <span style={{ display: 'block', marginTop: '10px' }}>
                        <i>
                          Please add these URLs to your Azure app's Redirect
                          URIs list as per your implementation.
                        </i>
                      </span>
                    </Label>
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <div className="integration-property">
                      {property.map((p, index) => {
                        return (
                          <CustomInput
                            key={p.id}
                            type="checkbox"
                            id={index}
                            label={p.name}
                            value={p.id}
                            name="property"
                            checked={
                              inputData.properties.filter((m) => m === p.id)
                                .length > 0
                                ? true
                                : false
                            }
                            onChange={handleCheckChange}
                          />
                        );
                      })}
                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Create New Integration
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Update Integration
                    </Button>
                  )}
                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
}
const mapStateToProps = (state) => ({
  serviceProvider: state.settings.serviceProvider,
});

export default connect(mapStateToProps)(AzureIntegration);
